/* eslint-disable local-rules/prefer-image-component-over-html-image-tag */
// eslint-disable-next-line monorepo/no-internal-import -- to avoid circular dependency in unit tests
import {Head} from '@aboutyou/head-elements/src/react-helmet-async';
import React, {ImgHTMLAttributes} from 'react';

export const PreloadableImage = React.forwardRef<
  HTMLImageElement,
  ImgHTMLAttributes<HTMLImageElement>
>(function PreloadableImage(
  {src, sizes, srcSet, importance, loading, ...props},
  ref,
) {
  const keyImage = importance === 'high' && loading !== 'lazy';

  return (
    <>
      {/** Helmet does not work in testing when process.browser is disabled, but we actually only want to have it on the server, that why we enable it explicitely on the testing setup */}
      {keyImage && (!process.browser || process.env.NODE_ENV === 'test') ? (
        <Head>
          <link
            rel="preload"
            as="image"
            imageSizes={sizes}
            imageSrcSet={srcSet}
            data-testid="preload-image-link"
            fetchpriority="high"
            {
              /**
               * We do not use the href attribute in the link preload
               * Reasoning is that all modern browsers ignore the href anyway because they can interpret the imageSizes&imageSrcSet attributes
               * despite of safari, which loads the image referenced in href.
               * Unfortunately that image is rather never the one being used later in the <img> because safari interprets srcSet and sizes attributes
               * So we preload unused image data
               *
               * By removing href safari will ignore the preload. There is no other relevant browser that interpets a link preload but NOT a img-srcSet
               * so there is not harm done by doing so.
               *
               * We need the href tag however in the test case because testing-library does not render the link when there is no unique href-attribute
               */
              ...(process.env.NODE_ENV === 'test' ? {href: src} : {})
            }
          />
        </Head>
      ) : (
        <></>
      )}
      <img
        height="100%"
        width="100%"
        decoding={keyImage ? 'sync' : 'async'}
        importance={importance}
        fetchpriority={importance}
        loading={loading}
        sizes={sizes}
        srcSet={srcSet}
        src={src}
        {...props}
        ref={ref}
      />
    </>
  );
});
